var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"change-vector-container",class:[_vm.way === 'next' ? 'next' : 'prev invert'],attrs:{"icon":"bootstrap-chevron-right","width":50,"height":37},nativeOn:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }